import { useState } from "react"
import { Link } from "react-router"
import { Form, FormikProps } from "formik"

import ContentCard from "../../../components/ContentCard"
import ErrorCard from "../../../components/ErrorCard"
import { SubmitButton } from "../../../components/SubmitButton"
import { WrappedInput } from "../../../components/Input"
import { BirddogLoginDataTypes } from "../types/auth"

interface BirddogLoginFormComponentProps
  extends FormikProps<BirddogLoginDataTypes> {
  errorMessage: string | null
}

const BirddogLoginFormComponent = ({
  isSubmitting,
  errorMessage,
}: BirddogLoginFormComponentProps) => {
  const [showPassword, setShowPassword] = useState(false)

  const toggleShowPassword = () => {
    setShowPassword(!showPassword)
  }

  return (
    <ContentCard>
      <h3 className="text-center text-lg leading-[1.50] tracking-[0.02em] mb-2">
        Sign in to BirdDog
      </h3>

      <Form className="space-y-4">
        {errorMessage && <ErrorCard>{errorMessage}</ErrorCard>}

        <div className="space-y-4">
          <div className="space-y-1">
            <WrappedInput
              data-test="input-email"
              label="Email address"
              name="email"
              placeholder="name@example.com"
              type="text"
              as="email"
            />
          </div>

          <div className="space-y-1">
            <WrappedInput
              data-test="input-password"
              label="Password"
              name="password"
              placeholder="Password"
              type={showPassword ? "text" : "password"}
              as="password"
              toggleShowPassword={toggleShowPassword}
            />
          </div>

          <div>
            <SubmitButton
              className="btn2 btn2-primary btn2-block font-semibold mt-6"
              isSubmitting={isSubmitting}
              data-test="birddog-sign-in"
            >
              Sign In
            </SubmitButton>
          </div>

          <div className="text-center">
            <Link to="/birddog/signup" className="link--underline-only">
              Don't have an account? <span className="link">Sign up</span>
            </Link>
          </div>
        </div>
      </Form>
    </ContentCard>
  )
}

export default BirddogLoginFormComponent
